/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationLogIncludeFilterItems } from './notificationLogIncludeFilterItems';
import { NotificationLogScopeFilter } from './notificationLogScopeFilter';


export interface NotificationLogIncludeFilterInner { 
    relation?: NotificationLogIncludeFilterInner.RelationEnum;
    scope?: NotificationLogScopeFilter;
}
export namespace NotificationLogIncludeFilterInner {
    export type RelationEnum = 'user';
    export const RelationEnum = {
        User: 'user' as RelationEnum
    };
}


